import {
  CROSS_ORIGIN_SCRIPT_ERROR_MESSAGES,
  NON_ATTRIBUTABLE_FRAME_MARKER,
} from "@/lib/errors/cross-origin-script-error/constants";

/**
 * True for the browser's sanitized cross-origin "Script error." (e.g. from the
 * cal.com embed iframe or an injected third-party script). These carry no
 * message, no stack and no source, so there is nothing to act on.
 *
 * Matches when the message is "Script error." or the SDK's
 * `Uncaught "Script error."` form, and the stack is missing or has only the
 * stub `at undefined @ ` frame. A real frame on the stack keeps it reportable.
 */
export function isCrossOriginScriptError(
  message: string | undefined,
  stack: string | undefined,
): boolean {
  if (!message || !CROSS_ORIGIN_SCRIPT_ERROR_MESSAGES.has(message)) {
    return false;
  }

  if (!stack) {
    return true;
  }

  return stack
    .split("\n")
    .filter((line) => line.trim().startsWith("at "))
    .every((frame) => frame.includes(NON_ATTRIBUTABLE_FRAME_MARKER));
}
